import { render, staticRenderFns } from "./pieces-hint.vue?vue&type=template&id=078256fe&"
import script from "./pieces-hint.vue?vue&type=script&lang=js&"
export * from "./pieces-hint.vue?vue&type=script&lang=js&"
import style0 from "./pieces-hint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports